var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 1.5C6.71452 1.5 5.45781 1.88122 4.38889 2.59545C3.31997 3.30968 2.48685 4.32484 1.99488 5.51256C1.50291 6.70028 1.37419 8.00721 1.62499 9.26809C1.87579 10.529 2.49486 11.6872 3.4039 12.5962C4.31294 13.5052 5.47113 14.1243 6.73201 14.3751C7.99288 14.6259 9.29982 14.4972 10.4875 14.0052C11.6753 13.5132 12.6904 12.6801 13.4046 11.6112C14.1189 10.5423 14.5001 9.28558 14.5001 8C14.4981 6.2767 13.8126 4.62456 12.5941 3.40601C11.3755 2.18745 9.72339 1.50199 8.0001 1.5ZM8.00003 4.5C8.14837 4.5 8.29337 4.54399 8.41671 4.6264C8.54005 4.70881 8.63618 4.82594 8.69294 4.96299C8.74971 5.10003 8.76456 5.25083 8.73562 5.39632C8.70668 5.5418 8.63525 5.67544 8.53036 5.78033C8.42547 5.88522 8.29184 5.95665 8.14635 5.98559C8.00086 6.01453 7.85006 5.99968 7.71302 5.94291C7.57598 5.88614 7.45884 5.79001 7.37643 5.66668C7.29402 5.54334 7.25003 5.39834 7.25003 5.25C7.25003 5.15151 7.26943 5.05398 7.30712 4.96299C7.34481 4.87199 7.40006 4.78931 7.4697 4.71967C7.53935 4.65003 7.62203 4.59478 7.71302 4.55709C7.80402 4.5194 7.90154 4.5 8.00003 4.5ZM8.5001 11.5H8.0001C7.93442 11.5 7.86939 11.4871 7.80871 11.462C7.74803 11.4369 7.69289 11.4001 7.64646 11.3536C7.60002 11.3072 7.56319 11.2521 7.53808 11.1914C7.51296 11.1307 7.50006 11.0657 7.5001 11V8C7.36749 8 7.24031 7.94732 7.14654 7.85355C7.05277 7.75979 7.00009 7.63261 7.00009 7.5C7.00009 7.36739 7.05277 7.24022 7.14654 7.14645C7.24031 7.05268 7.36749 7 7.5001 7H8.0001C8.06577 6.99996 8.1308 7.01287 8.19148 7.03798C8.25216 7.0631 8.3073 7.09993 8.35373 7.14636C8.40017 7.1928 8.437 7.24793 8.46211 7.30861C8.48723 7.36929 8.50013 7.43433 8.5001 7.5V10.5C8.6327 10.5 8.75988 10.5527 8.85365 10.6464C8.94742 10.7402 9.0001 10.8674 9.0001 11C9.0001 11.1326 8.94742 11.2598 8.85365 11.3536C8.75988 11.4473 8.6327 11.5 8.5001 11.5Z",
    fill: "url(#paint0_linear_178_623)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_623",
    x1: 8.00009,
    y1: 1.5,
    x2: 8.00009,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB775"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a5d9c4a1bb8e9a5993dbb24cb8a2151d.svg";
export { ForwardRef as ReactComponent };